// @ts-ignore
import * as React from "react";

import { isNotNullOrUndefined } from "../../../../../../../../Common/TypingUtils";
import { ItemErrorMessage } from "../../../../../../Engine/Core/ErrorManager/Utils/Models";
import { safeHTML } from "../../../../../../Engine/Core/ErrorManager/Utils/Utils";

import { HiddenText } from "./HiddenText/HiddenText";

export interface TagToken {
    textContent: string | null;
    tagName: string | null;
    attributes: AttributesTypes;
    node: HTMLElement | null;
}

export interface HiddenTextAttributes {
    length?: number;
    hinttext?: string;
    buttonlink?: string;
    buttontext?: string;
}

type AttributesTypes = HiddenTextAttributes | null;

export function hasHiddenTextInDescription(item: ItemErrorMessage[]) {
    return item.some(checkHiddenTextInErrorItem);
}

export function checkHiddenTextInErrorItem(item: ItemErrorMessage) {
    if ("hideLinks" in item) {
        return item.hideLinks;
    }
    return false;
}

export function hasHiddenText(text: string) {
    return parseTags(text).some(tag => tag.tagName === "HIDDEN");
}

export function getPreparedText(text: string) {
    const xmlTags = parseTags(text);
    const result = xmlTags.map(tag => {
        if (tag?.tagName === "HIDDEN") {
            return <HiddenText key={crypto.randomUUID()} {...tag.attributes} />;
        }
        return tag.node?.outerHTML ?? tag.textContent;
    });

    return result
        .filter(isNotNullOrUndefined)
        .map(node =>
            typeof node === "string" ? (
                <span dangerouslySetInnerHTML={{ __html: safeHTML(node) }} key={crypto.randomUUID()} />
            ) : (
                node
            )
        );
}

function extractAttributes(node: HTMLElement): AttributesTypes {
    const attributes = {};
    if (node?.attributes?.length > 0) {
        for (const attr of node.attributes) {
            // @ts-ignore
            attributes[attr.name.replace("-", "_")] = attr.value;
        }
    }
    return attributes as AttributesTypes;
}

function parseTags(html: string): TagToken[] {
    const tags: TagToken[] = [];

    if (!globalThis.DOMParser) {
        return [];
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const nodes = doc.body.childNodes;
    for (const node of nodes) {
        const strictNode = node as HTMLElement;
        const { tagName = null, textContent = null } = strictNode;
        const attributes = extractAttributes(strictNode);

        tags.push({ tagName: tagName, textContent: textContent, attributes: attributes, node: strictNode });
    }

    // например, пробел
    if (tags.length === 0) {
        return [
            {
                textContent: html,
                tagName: null,
                attributes: null,
                node: null,
            },
        ];
    }

    // при parseFromString слетает лидирующий пробел в строке, надо вернуть, тк текст начинает слипаться
    if (html.match(/^\s/) && tags[0]?.textContent) {
        tags[0].textContent = ` ${tags[0]?.textContent}`;
    }

    return tags;
}
// Кевеб присылает нам ссылку с &amp; в урле, а не просто &, это неправильно и образовался баг https://yt.skbkontur.ru/issue/FS-8893
// Если они это починят то это можно спокойно дропунть
export const replaceExternalLink = (link?: string) => link?.replaceAll("&amp;", "&");
